import { Avatar, Box, Stack, Typography } from '@mui/material';
import React from 'react';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

export const ContentParser = ({ value }: { value: string }) => {
  return (
    <Box
      sx={{
        a: {
          color: 'inherit',
        },
      }}
    >
      {parse(DOMPurify.sanitize(value))}
    </Box>
  );
};

interface IMessageToProps {
  body: any;
  time: string;
  avatar: any;
  authorName: string;
  tags?: string[];
  conversationId: string;
  conversationPartIdRef: string;
  tagCurrent?: string;
}

export const MessageTo = ({
  body,
  time,
  avatar,
  authorName,
  tags,
  conversationId,
  conversationPartIdRef,
  tagCurrent,
}: IMessageToProps) => {
  const refAbsolute = React.useRef<any>();
  const [tagRowWidth, setTagRowWidth] = React.useState<number>();

  // See MessageFrom: the absolutely-positioned tag row sets a floor on the
  // bubble width. Fixed width froze bubbles at their mount-time size, which
  // breaks once the thread renders inside the narrower inbox pane.
  React.useEffect(() => {
    setTagRowWidth(tags?.length ? refAbsolute.current?.scrollWidth : undefined);
  }, [tags]);

  return (
    <Stack direction={'row'} spacing={1} alignItems={'end'} padding={'8px'}>
      <Stack
        sx={{
          backgroundColor: '#EEF0FB',
          padding: '12px',
          minWidth: tagRowWidth,
          textAlign: 'right',
          maxWidth: '80%',
          borderRadius: '15px',
          boxShadow: '0px 2px 8px 0px #00000026',
          position: 'relative',
          zIndex: 1,
        }}
        style={{
          marginLeft: 'auto',
        }}
        spacing={1}
      >
        <Stack
          sx={{
            width: 'max-content',
            position: 'absolute',
            top: '-16px',
            left: '0px',
            zIndex: 2,
            minWidth: '160px',
          }}
          direction={'row'}
          ref={refAbsolute}
        >
          {tags &&
            tags.length > 0 &&
            tags.map((tag) => {
              return (
                <>
                  <Typography
                    sx={{
                      color: '#356766',
                      backgroundColor:
                        conversationId === conversationPartIdRef &&
                        tagCurrent === tag
                          ? 'rgba(239, 207, 81, 0.44)'
                          : '#EAEFEF',
                      border: '1px solid #356766',
                      borderRadius: '20px',
                      paddingX: '8px',
                      height: '24px',
                      fontSize: '14px',
                      fontWeight: 500,
                      marginRight: '4px',
                      boxShadow: '2px 2px rgba(0, 0, 0, 0.25)',
                    }}
                  >
                    {tag}
                  </Typography>
                </>
              );
            })}
        </Stack>
        <Typography
          sx={{
            lineHeight: '18px',
            textAlign: 'left',
            fontSize: '14px',
            fontWeight: 400,
            color: '#000000',
            wordWrap: 'break-word',
          }}
        >
          <ContentParser value={body || ''} />
        </Typography>
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            color: '#7D818C',
          }}
        >
          {time}
        </Typography>
      </Stack>
      {avatar ? (
        <img
          src={avatar}
          style={{
            borderRadius: '50%',
          }}
          className="h-[23px] w-[23px]"
        />
      ) : (
        <Avatar
          sx={{
            color: 'white',
            fontSize: '13px',
            backgroundColor: '#213B54',
            fontWeight: 600,
          }}
          className="!h-[23px] !w-[23px]"
        >
          {authorName?.trim()?.charAt(0) || ''}
        </Avatar>
      )}
    </Stack>
  );
};
